<template>
    <div>

        <config-main-title>
            Tipo de Alta
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Tipo de Alta Identificado.'" 
                icon="fa-solid fa-person-walking-dashed-line-arrow-right"
                action="Incluir Tipo de Alta" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2">#{{  dado.id_tipo_alta }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <span v-else>
                            <span class="badge badge-secondary" v-if="dado.st_codigo_tiss">
                                {{ dado.st_codigo_tiss }}
                            </span>
                        </span>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_tipo_alta ) ? '' : 'Novo' }}
                            Tipo de Alta
                            <span v-if="item && item.id_tipo_alta">
                                #{{ item.id_tipo_alta }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Descrição..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_nome" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Código TISS..."
                                    type="number"
                                    :validate="validate"
                                    v-model="item.st_codigo_tiss" />
                            </div>
                        </div>

                        <div class="form-row mt-3">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Informar Declaração de Óbito"
                                    :validate="validate"
                                    required
                                    v-model="item.fl_info_dobito" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="tipoAlta" :id="item.id_tipo_alta" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_tipo_alta ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['teste'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },
    },

    methods: { 
        incluir () { 
            this.validate = false;

            let item = {
                id_tipo_alta: null, 
                st_nome: "", 
                st_codigo_tiss: "primary",
                fl_ativo: true,
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'tipo_altas',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'tipo_altas',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'tipo_altas',
                dados: item,
            });

        },
    },

    mounted () { 
        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Tipo de Alta" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.load();

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>